<template>
	<a-button-group class="gupload">
		<!-- <template v-if="multiple">
			<a-upload
				name="file"
				:file-list="fileList"
				:accept="accept"
				:multiple="false"
				:custom-request="upload"
				class="gupload-list"
			>
				<a-button class="gupload-btn1">
					<span v-if="fileList.length > 0">
						<a
							:href="item.url"
							target="_blank"
						>
							<fa-icon
								:icon="['far', 'file']"
								class="mr-2"
							/> {{ fileList[0].name }}
						</a>
					</span>

					<span v-else>
						<fa-icon
							:icon="['fas',loading ? 'spinner' : 'upload']"
							class="mr-2"
							:spin="loading"
						/>

						Subir fichero
					</span>
				</a-button>
			</a-upload>

			<a-popover
				v-model="fileListVisible"
				placement="bottomRight"
				trigger="click"
			>
				<template slot="title">
					<span>{{ fileList.length }} Fichero/s</span>
				</template>
				<template slot="content">
					<div
						v-for="(media, index) in fileList"
						:key="index"
						class="d-flex"
					>
						<div class="mr-4">
							<a
								:href="media.url"
								target="_blank"
							>
								<fa-icon
									:icon="['far', 'file']"
									class="mr-2"
								/> {{ media.name }}
							</a>
						</div>

						<div class="ml-auto text-danger bl-1">
							<a-popconfirm
								:title="`¿Estas seguro que deseas eliminar el fichero ${media.name} ?`"
								@confirm="() => unload(media)"
							>
								<fa-icon
									:icon="['fas', 'trash-alt']"
									class="ml-3 pointer"
								/>
							</a-popconfirm>
						</div>
					</div>
				</template>
				<a-button>
					<fa-icon
						:icon="['fas', fileListVisible ? 'folder-open' : 'folder']"
						:class="fileList.length === 0 ? 'text-muted' : ''"
					/>
				</a-button>
			</a-popover>
		</template> -->

		<template>
			<a-upload
				v-if="fileList.length === 0"
				name="file"
				:file-list="fileList"
				:accept="accept"
				:multiple="false"
				:custom-request="upload"
				class="gupload-list"
			>
				<a-button
					class="gupload-btn1 text-gray-5"
					:size="size"
				>
					<fa-icon
						:icon="['far', 'file']"
						class="mr-2"
					/>  Subir fichero
				</a-button>

				<a-button
					class="gupload-btn2"
					:size="size"
				>
					<fa-icon
						:icon="['fas',loading ? 'spinner' : 'upload']"
						:spin="loading"
					/>
				</a-button>
			</a-upload>

			<template v-else>
				<a-button
					class="gupload-btn1"
					:size="size"
					@click="goTo(fileList[0].url)"
				>
					<fa-icon
						:icon="['far', 'file']"
						class="mr-2"
					/> {{ fileList[0].name }}
				</a-button>

				<a-popconfirm
					v-if="fileList.length > 0"
					:title="`¿Estas seguro que deseas eliminar el fichero ${fileList[0].name} ?`"
					@confirm="() => unload(fileList[0])"
				>
					<a-button :size="size">
						<fa-icon
							:icon="['fas', 'trash-alt']"
							class="pointer text-danger"
						/>
					</a-button>
				</a-popconfirm>
			</template>
		</template>
	</a-button-group>
</template>

<script>
// INFO: Only multiple:false available per moment

export default {
	name: 'GUpload',
	props: {
		value: {
			type: Object,
			default: undefined
		},
		accept: {
			type: String,
			default: ''
		},
		// Media params
		fileName: {
			type: String,
			default: ''
		},
		folderName: {
			type: String,
			default: ''
		},
		// GestiOS Sync
		name: {
			type: String,
			default: ''
		},
		app: {
			type: String,
			default: ''
		},
		item: {
			type: Number,
			default: null
		},
		size: {
			type: String,
			default: 'default'
		}
	},
	data() {
		return {
			multiple: false,
			loading: false,
			fileListVisible: false,
			fileList: []
		};
	},
	computed: {
		url() {
			return `${this.$gestios.url}/${this.$gestios.project.name}/media/add`;
		},
		headers() {
			return {
				'X-API-KEY': this.$gestios.profile.API
			};
		},
		sync() {
			if (this.app && this.name) {
				const data = this.$gestios.$cache.app(this.app).data();
				if (data && data.Fields[this.name]) return data.Fields[this.name];
			}
			return false;
		}
	},
	watch: {
		fileListVisible(val) {
			if (val && this.fileList.length === 0) this.fileListVisible = false;
		},
		value(val) {
			this.init(val);
		}
	},
	created() {
		if (this.sync && this.value === undefined) {
			const data = this.$gestios.$cache.items(this.app).get(this.item);
			if (data && data[this.name]) {
				const file = data[this.name];

				this.fileList = [{
					uid: file._EntityId,
					name: file.Name,
					status: 'done',
					url: file.Link
				}];
			}
		} else {
			this.init(this.value);
		}
	},
	methods: {
		async upload(params) {
			this.loading = true;

			const upload = await this.$gestios.media.add({
				file: params.file,
				name: this.fileName,
				folder: this.folderName
			});

			if (upload.ok) {
				const file = upload.data;

				if (this.sync) {
					const edit = await this.$gestios.items(this.app).edit({
						id: this.item,
						params: {
							[this.name]: file._EntityId
						}
					});

					if (!edit.ok) {
						this.$message.error('Se subió el fichero pero no se pudo adjuntar a la aplicación');
						this.$emit('onError', { data: file, error: edit.message, code: edit.code });
						return false;
					}
				}

				this.fileList.push({
					uid: file._EntityId,
					name: file.Name,
					status: 'done',
					url: file.Link
				});

				this.loading = false;
				this.$message.success('Fichero subido correctamente');

				return true;
			}

			this.loading = false;
			this.$message.error('No se ha podido subir el fichero especificado');

			return false;
		},
		async unload(item) {
			const unload = await this.$gestios.media.delete(item.uid);

			if (unload.ok) {
				if (this.sync) {
					this.$gestios.$cache.items(this.app).edit({
						id: this.item,
						params: {
							[this.name]: null
						}
					});
				}

				const index = this.fileList.findIndex((f) => f.uid === item.uid);
				if (index > -1) this.fileList.splice(index, 1);

				this.$message.success('Fichero eliminado correctamente');
			} else {
				this.$message.error('No se pudo eliminar el fichero especificado');
			}
		},
		goTo(url) {
			const win = window.open(url, '_blank');
			win.focus();
		},
		init(val) {
			if (val === undefined) val = null;

			if (val) {
				if (Array.isArray(val)) {
					this.fileList = [];

					for (let i = 0; i < val.length; i += 1) {
						const f = val[i];

						this.fileList.push({
							uid: f._EntityId,
							name: f.Name,
							status: 'done',
							url: f.Link
						});
					}
				} else {
					const f = val;

					this.fileList = [{
						uid: f._EntityId,
						name: f.Name,
						status: 'done',
						url: f.Link
					}];
				}
			} else {
				this.fileList = [];
			}
		}
	}
};
</script>

<style lang="scss">
	.gupload{
		white-space: nowrap;

		.gupload-list{
			.ant-upload-list {
				display: none
			}

		}

		.ant-upload{
			border-radius: 6px !important;
		}

		.gupload-btn1{
			position: relative;
			text-align: left;
			width: 150px;
			overflow-x: hidden;
			border-radius: 6px 0 0 6px !important;
		}

		.gupload-btn1::after{
			position: absolute;
			display: block;
			content: ' ';
			right: 0;
			top: 0;
			height: 100%;
			background: rgb(255,255,255);
			background: linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%,
				rgba(255,255,255,1) 50%, rgba(255,255,255,0.6418942577030813) 100%);
			width: 20px;
		}

		.gupload-btn2{
			border-radius: 0 6px 6px 0 !important;
		}
	}
</style>
